import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MessageService, SelectItem, Message} from 'primeng/api';
import {Router, ActivatedRoute} from '@angular/router';
import {AutenticacaoService} from '../../services/autenticacao.service';
import {first} from 'rxjs/operators';
import {MensagensMeioAcessoLogin} from '../../enum/mgs-meio-acesso.enum'
import {ReCaptchaV3Service} from 'ngx-captcha';
import {SharedService} from "../../services/shared.service";
import {Beneficiario} from "../../shared/models/beneficiario.model";
import { ThemeService } from '../../services/theme.service';
import { BusinessService } from '../../services/business.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [MessageService]
})
export class LoginComponent implements OnInit {
  public siteKey;

  msgs: Message[] = [];
  formlogin: FormGroup;
  tiposLogin: SelectItem[];
  enumMensagens = MensagensMeioAcessoLogin;
  tipoLoginSelecionado: string;
  submitted: boolean;
  loading: boolean;

  constructor(private fb: FormBuilder, private messageService: MessageService, private router: Router,
              private activatedRouter: ActivatedRoute,
              private businessService: BusinessService,
              private themeService: ThemeService,
              private autenticacaoService: AutenticacaoService,
              private reCaptchaV3Service: ReCaptchaV3Service, private sharedService: SharedService) {
    this.autenticacaoService.logout();
    this.sharedService.beneficiario = new Beneficiario();
    if (this.autenticacaoService.currentUserValue) {
      this.reCaptchaV3Service.execute(this.siteKey, 'login', (token) => {
      }, {
        useGlobalDomain: false // optional
      });
      this.router.navigate(['./selecionar-beneficiario']);
    }
  }

  ngOnInit() {
    this.getRecaptcha();
    this.formlogin = this.fb.group({
      login: new FormControl('', [Validators.required, Validators.email]),
      senha: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(6)])),
    });

    this.tipoLoginSelecionado = '1';
    this.tiposLogin = [
      {label: 'E-mail', value: '1'},
      {label: 'CPF', value: '2'},
      {label: 'Carteira', value: '4'},
    ];

    this.activatedRouter.queryParams.subscribe((params) => {
      const businessId = params['cod_empresa'];
      if (businessId) {
        this.setBusinessId(businessId);
        this.updateTheme(businessId);
      } else {
        this.setBusinessId('1');
        this.updateTheme('1');
      }
    });
  }

  getRecaptcha() {
    this.autenticacaoService.getAll().subscribe((res: any) => {
      this.siteKey = res.siteKey;
      this.reCaptchaV3Service.execute(this.siteKey, 'login', (token) => {
      }, {
        useGlobalDomain: false // optional
      });
    });
  }

  onSubmit(value) {
    this.submitted = true;
    this.loading = true;
    this.messageService.clear();

    if (this.tipoLoginSelecionado.endsWith("2") && value.login.length != 11) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'CPF inválido'});
    } else if (this.tipoLoginSelecionado.endsWith("4") && value.login.length != 14) {
      this.loading = false;
      this.messageService.add({severity: 'warn', summary: 'Carteira inválido'});
    } else {
      this.autenticacaoService.login(value.login, value.senha, this.tipoLoginSelecionado).pipe(first()).subscribe((beneficiario) => {
          this.loading = false;
          if (beneficiario != null) {
            this.redirecinaSolicitacoes(beneficiario);
            this.router.navigate(['./selecionar-beneficiario']);
          } else {
            this.messageService.add({severity: 'warn', summary: 'Login e/ou senha inválido(s)'});
          }
        },
        error => {
          this.loading = false;
          if (error == "Unknown Error") {
            this.messageService.add({
              severity: 'error',
              summary: 'Estamos com problemas... Tente novamente em alguns instantes.'
            });
          } else {
            this.messageService.add({severity: 'warn', summary: 'Login e/ou senha inválido(s)'});
          }
        });
    }
  }

  onChange(event) {
    this.formlogin.setValue({login: '', senha: ''});
  }

  redirecinaSolicitacoes(beneficiario) {
    this.sharedService.beneficiario = beneficiario;
    this.router.navigate(['./selecionar-beneficiario']);
  }

  toUperCase(value: any) {
    this.formlogin.value.login = value.login.toUpperCase();
  }

  setBusinessId(businessId: string) {
    this.businessService.setBusinessId(businessId);
  }

  getBusinessId() {
    return this.businessService.getBusinessId();
  }

  getSelectedTheme() {
    return this.themeService.getSelectedTheme();
  }

  updateTheme(businessId: string) {
    this.themeService.setSelectedTheme(businessId);
    this.themeService.updateTheme(businessId);
  }

  exibirLinkRegistrar() {
    return this.businessService.temLinkRegistrar();
  }

  getLinkRegistrar() {
    return this.businessService.getLinkRegistrar();
  }

  codEmpresaUrlParams() {
    return (this.businessService.getBusinessId() === "1") ? {} : {cod_empresa: this.getBusinessId()};
  }

  mostrarSomenteSeHapvida() {
    return (this.businessService.getBusinessId() === "1");
  }

}
